<template>
<div class="kalem">
  <v-dialog v-model="dialogShow" max-width="1024px" persistent scrollable>
    <v-card>
      <v-system-bar window color="primary" dark>
        {{SaticiTipToStr(val.kalem.saticiTip)}}  {{ $t('Item-Details') }}
        <v-spacer></v-spacer>
        <v-icon>remove</v-icon>
        <v-icon @click="maxWidth=''">check_box_outline_blank</v-icon>
        <v-icon @click.stop="value.dialogShow=false">close</v-icon>
      </v-system-bar>

      <!--
      <v-toolbar card dark color="primary">
        <v-btn icon dark @click.native="value.dialogShow=false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{SaticiTipToStr(val.kalem.saticiTip)}}  {{ $t('Item-Details') }} </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark flat @click.native="modalOk()">{{ $t('OK') }}</v-btn>

        </v-toolbar-items>
        <v-menu bottom right offset-y>
          <v-btn slot="activator" dark icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile v-for="(item, i) in menuItems" :key="i" @click="menuClick(i)">
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-tabs slot="extension" v-model="tabmodel" dark color="primary" slider-color="yellow">
          <v-tab :href="`#tab-genel`">GENEL</v-tab>
          <v-tab :href="`#tab-maliyet`">MALİYET</v-tab>
          <v-tab :href="`#tab-komisyon`">KOMİSYON</v-tab>
          <v-tab :href="`#tab-aciklama`">AÇIKLAMA</v-tab>
          <v-tab :href="`#tab-diger`">DIGER</v-tab>
        </v-tabs>

      </v-toolbar>
      -->
      <div>
        <v-tabs slot="extension" v-model="tabmodel" >
          <v-menu bottom right offset-y>
          <v-btn slot="activator" icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile v-for="(item, i) in menuItems" :key="i" @click="menuClick(i)">
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
          <v-tab :href="`#tab-genel`"> {{ $t('tab_general') }} </v-tab>
          <v-tab :href="`#tab-maliyet`">MALİYET</v-tab>
          <v-tab :href="`#tab-komisyon`">{{$t('Commission')}}</v-tab>
          <v-tab :href="`#tab-aciklama`">{{ $t('Description') }}</v-tab>
          <v-tab :href="`#tab-diger`">{{ $t('Other') }} </v-tab>
        </v-tabs>
      </div>

      <v-card-text style="height: 850px;">

        <v-tabs-items v-model="tabmodel">
          <v-tab-item :id="`tab-genel`">

            <v-layout row wrap>
              <div class="flex md4">

                <genelarama apiname="SaticiAra" :tip="val.kalem.saticiTip" label="Satıcı Kod :" v-model="val.kalem.satici"></genelarama>
                <genelarama apiname="MasrafMerkeziAra" :label="$t('Expense-Center-v2') +  ':'" v-model="val.kalem.masrafMerkezi"></genelarama>
                <genelarama apiname="SaticiAra" :tip="12" :label="$t('Tour-Operator') + ':'" v-model="val.kalem.turOperatoru"></genelarama>
                <geneltipara tip="AcenteDepartman" v-model="val.kalem.departman"></geneltipara>

                <v-layout>
                  <v-text-field type='date' hide-details :label="$t('Period-v2') + '1 :'" v-model="val.kalem.donem1"></v-text-field>
                  <v-text-field type='date' hide-details :label="$t('Period-v2') + '2 :'" v-model="val.kalem.donem2"></v-text-field>
                </v-layout>
                <v-select hide-details :items="odemeTipi" :label="$t('Payment-Type')" item-text="aciklama" item-value="kod" v-model="val.kalem.odeyenTaraf"></v-select>

                <template v-if="val.kalem.saticiTip==1">
                  <v-select hide-details :items="pansiyon" :label="$t('Hostel')" item-text="aciklama" item-value="kod" v-model="val.kalem.kalemOtel.pansiyon"></v-select>
                  <v-text-field hide-details :label="$t('Entry-Date')" v-model="val.kalem.kalemOtel.giriSaat"></v-text-field>
                  <genelarama apiname="OdaTipiAra" :label="$t('Room-type') + ':'" v-model="val.kalem.kalemOtel.odaTipi"></genelarama>
                  <genelaramakod apiname="OdaKonumAra" :tip="val.kalem.satici.kod" hide-details :label="$t('Location') + ':'" v-model="val.kalem.kalemOtel.konum"></genelaramakod>
                  <v-text-field type=number hide-details :label="$t('Room-Number')" v-model="val.kalem.kalemOtel.odaSayi"></v-text-field>
                  <v-checkbox hide-details :label="$t('Capacity')" v-model="val.kalem.kalemOtel.kontenjan"></v-checkbox>
                  <v-text-field type=number hide-details label="freeKisi :" v-model="val.kalem.kalemOtel.freeKisi"></v-text-field>
                  <geneltipara tip="OtelFiyatKod" label="fiyatKodu :" v-model="val.kalem.kalemOtel.fiyatKodu"></geneltipara>

                </template>
                <template v-if="val.kalem.saticiTip==10">
                  <v-textarea hide-details :label="$t('Job-Explanation')" v-model="val.kalem.kalemDiger.isAciklama"></v-textarea>
                </template>
              </div>
              <div class="flex md4">
                <v-layout>
                  <div class="flex md9">
                    <kur v-model="val.kalem.satisPara" :kurtarihi="val.Rez.kayitTarihi"></kur>
                  </div>
                  <div class="flex md3">
                    <v-text-field hide-details :label="$t('VAT')" v-model="val.kalem.satis.KDVOran"></v-text-field>
                  </div>
                </v-layout>

                <v-text-field hide-details label="Yet Satış :" v-model="val.kalem.yet_Satis"></v-text-field>

                <template v-if="(val.kalem.saticiTip==1) || (val.kalem.saticiTip==10) || (val.kalem.saticiTip==9) ">
                  <v-text-field hide-details label="Co1 Satış :" v-model="val.kalem.co1_Satis"></v-text-field>
                  <v-text-field hide-details label="Co2 Satış :" v-model="val.kalem.co2_Satis"></v-text-field>
                  <v-text-field hide-details label="Co3 Satış :" v-model="val.kalem.co3_Satis"></v-text-field>
                  <v-text-field hide-details label="Co4 Satış :" v-model="val.kalem.co4_Satis"></v-text-field>
                  <v-text-field hide-details label="EkY Satış :" v-model="val.kalem.ekY_Satis"></v-text-field>
                </template>

                <template v-if="(val.kalem.saticiTip==2) || (val.kalem.saticiTip==8) ">
                  <v-text-field hide-details label="Co1 Satış :" v-model="val.kalem.co1_Satis"></v-text-field>
                  <v-text-field hide-details label="Co2 Satış :" v-model="val.kalem.co2_Satis"></v-text-field>
                </template>
                <template v-if="(val.kalem.saticiTip==3)||(val.kalem.saticiTip==5)||(val.kalem.saticiTip==7)||(val.kalem.saticiTip==7) ||(val.kalem.saticiTip==11)||(val.kalem.saticiTip==14) || (val.kalem.saticiTip==15) || (val.kalem.saticiTip==16)">

                </template>
                <template v-if="(val.kalem.saticiTip==4) ">
                  <v-text-field hide-details label="Co1 Satış :" v-model="val.kalem.co1_Satis"></v-text-field>
                </template>

                <!-- İskonto *************************************** -->

                <v-layout>
                  <v-text-field hide-details :label="$t('Discount-Rate')" v-model="val.kalem.iskonto.oran"></v-text-field>
                  <v-text-field hide-details :label="$t('Discount-Amount')" v-model="val.kalem.iskonto.tutar"></v-text-field>
                </v-layout>
                <v-text-field hide-details :label="$t('Discount-reason')" v-model="val.kalem.iskonto.iskontoSebebi"></v-text-field>

              </div>
              <div class="flex md4">
                {{val}}

                <template>
                  <v-data-table :headers="headers" :items="val.adresler" :search="search" v-model="selected" item-key="adSoyad" select-all class="elevation-1" hide-actions>
                    <template slot="headerCell" slot-scope="props">
                      <v-tooltip bottom>
                        <span slot="activator">{{ props.header.text }}</span>
                        <span> {{ props.header.text }} </span>
                      </v-tooltip>
                    </template>
                    <template slot="items" slot-scope="props">
                      <tr :active="props.selected" @click="props.selected = !props.selected;">
                        <td>
                          <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
                        </td>
                        <td>{{ props.item.adSoyad }}</td>
                      </tr>
                    </template>
                  </v-data-table>

                </template>

              </div>

            </v-layout>

          </v-tab-item>

          <v-tab-item :id="`tab-maliyet`">
         <cariaracomp v-bind:etiket="$t('Cost-Current')" v-bind:value="val.kalem.maliyetCariKod.kod" v-model="val.kalem.maliyetCariKod.kod" :Coper="true"></cariaracomp>
            <v-layout>
              <div class="flex md3">
                <v-text-field hide-details :label="$t('Profit-VAT')" v-model="val.kalem.karKDV"></v-text-field>
              </div>
              <div class="flex md9">
                <kur v-model="val.kalem.alisPara" :kurtarihi="val.Rez.kayitTarihi"></kur>
              </div>
            </v-layout>

            <template v-if="(val.kalem.saticiTip==1)">
              <v-combobox hide-details :label="$t('Rom-Pax-Total')" v-model="val.kalem.kalemOtel.RP" :items="['R','P','T']"></v-combobox>
            </template>

            <v-text-field hide-details label="Yet Alış :" v-model="val.kalem.yet_Alis"></v-text-field>
            <template v-if="(val.kalem.saticiTip==1) || (val.kalem.saticiTip==10) || (val.kalem.saticiTip==9) ">
              <v-text-field hide-details label="Co1 Alış :" v-model="val.kalem.co1_Alis"></v-text-field>
              <v-text-field hide-details label="Co2 Alış :" v-model="val.kalem.co2_Alis"></v-text-field>
              <v-text-field hide-details label="Co3 Alış :" v-model="val.kalem.co3_Alis"></v-text-field>
              <v-text-field hide-details label="Co4 Alış :" v-model="val.kalem.co4_Alis"></v-text-field>
              <v-text-field hide-details label="EkY Alış :" v-model="val.kalem.ekY_Alis"></v-text-field>
            </template>

            <template v-if="(val.kalem.saticiTip==2) || (val.kalem.saticiTip==8) ">
              <v-text-field hide-details label="Co1 Alış :" v-model="val.kalem.co1_Alis"></v-text-field>
              <v-text-field hide-details label="Co2 Alış :" v-model="val.kalem.co2_Alis"></v-text-field>
            </template>
            <template v-if="(val.kalem.saticiTip==3)||(val.kalem.saticiTip==5)||(val.kalem.saticiTip==7)||(val.kalem.saticiTip==7) ||(val.kalem.saticiTip==11)||(val.kalem.saticiTip==14) || (val.kalem.saticiTip==15) || (val.kalem.saticiTip==16)">

            </template>
            <template v-if="(val.kalem.saticiTip==4) ">
              <v-text-field hide-details label="Co1 Alış :" v-model="val.kalem.co1_Alis"></v-text-field>
            </template>

          </v-tab-item>

          <v-tab-item :id="`tab-komisyon`">

            <v-autocomplete hide-details :label="$t('Calculate-Commission-Percentage')" v-model="val.kalem.komisyonYuzdeTip" item-text="t" item-value="v" :items="[{t: $t('Calculate-From-Sales-Price'), v:0},{t:$t('Calculate-From-Purchasing-Price'), v:1}]"></v-autocomplete>
            <v-text-field hide-details label="Kom. Yüzde :" v-model="val.kalem.komisyonYuzde"></v-text-field>
            <v-text-field hide-details label="Kom. Tutar :" v-model="val.kalem.komisyonTutar"></v-text-field>
            <kur v-model="val.kalem.komisyonPara" :kurtarihi="val.Rez.kayitTarihi"></kur>
            <v-text-field hide-details label="Kom. KDV :" v-model="val.kalem.komisyon.KDVOran"></v-text-field>

          </v-tab-item>

          <v-tab-item :id="`tab-aciklama`">

            <v-textarea hide-details :label="$t('Descriptions')+':'" v-model="val.kalem.aciklama"></v-textarea>
            <v-textarea hide-details :label="$t('Supplier-Explanations')" v-model="val.kalem.tedarikciAciklama"></v-textarea>

          </v-tab-item>

          <v-tab-item :id="`tab-diger`">
            <v-text-field hide-details :label="$t('Integration-Code')" v-model="val.kalem.entegrasyonKodu"></v-text-field>
            <geneltipara tip="CariKdvKod" hide-details :label="$t('VAT-Code')+':'" v-model="val.kalem.kdvID"></geneltipara>
            <geneltipara tip="CariKdvIstisnaKod" hide-details :label="$t('VAT-Exception-Code')" v-model="val.kalem.kdvMuafiyetID"></geneltipara>

          </v-tab-item>

        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-btn color=primary flat @click.native="modalOk()"> {{ $t('OK') }} </v-btn>
        <v-btn color=red flat @click.stop="value.dialogShow=false"> {{ $t('cancel_button') }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</div>
</template>

<script>
import rez from "../rezervasyon";
import kur from "@/components/app/coper/comp/kur.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import genelaramakod from "@/components/app/coper/comp/genelaramakod.vue";
import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'

export default {
  components: {
    kur,
    genelarama,
    genelaramakod,
    geneltipara,
    cariaracomp
  },

  props: ["value"],
  computed: {
    val: {
      get: function () {
        if (this.value.dialogShow == true) {
          var selected2 = [];
          for (var i = 0; i < this.value.kalem.kisiSira.length; i++) {
            selected2.push(this.value.adresler[this.value.kalem.kisiSira[i]]);
          }
          this.setSelected(selected2);
        }
        this.setDialogShow(this.value.dialogShow);
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      }
    },
    pansiyon: {
      get: function () {
        return rez.Pansiyon;
      }
    }
  },

  data() {
    return {
      dialogShow: false,

      error: "",
      adresler: [],
      search: "",
      selected: [],
      odemeTipi: rez.OdemeTipi,

      tabmodel: "tab-genel",

      kisiSira: [],
      headers: [{
        text: "Isim",
        align: "left",
        value: "adSoyad",
        sortable: false
      }],
      menuItems: [{
          title: this.$t('Find-Price')
        },
        {
          title: this.$t('Calculate-Price')
        }
      ]
    };
  },

  created() {},
  methods: {
    //Ara:Ara,

    menuClick: menuClick,
    SaticiTipToStr(tip) {
      return rez.SaticiTipToStr(tip);
    },

    setSelected(v) {
      this.selected = v;
    },
    setDialogShow(v) {
      this.dialogShow = v;
    },

    close() {
      this.value.dialogShow = false;
      setTimeout(() => {
        this.value.kalem = Object.assign({}, rez.Kalem());

        this.value.editedIndex = -1;
      }, 300);
    },

    modalOk() {
      this.value.kalem.kisiSira = [];
      for (var i = 0; i < this.selected.length; i++) {
        this.value.kalem.kisiSira.push(this.selected[i].kisiSira);
      }

      if (this.value.editedIndex > -1) {
        Object.assign(
          this.value.Rez.kalemler[this.value.editedIndex],
          this.value.kalem
        );
      } else {
        this.value.Rez.kalemler.push(this.value.kalem);
      }
      this.close();
    }
  }
};

function menuClick(v) {

}
</script>
